export default __webpack_public_path__ + "static/media/ontokens-icon.9c4f6faf.PNG";